import React, { useMemo } from 'react'

import toast from 'react-hot-toast'
import { PiFileAudio, PiTrash } from 'react-icons/pi'

import { UploadedItemsBtn, UploadedItems, FilesList } from './style'
import { useStorage } from '../../../context'
import { AudioRef, FileItem } from '../../../types'

const UploadedFilesList = ({
  userId,
  logUID,
  updateLogData,
  defaultValue,
  files,
}: {
  userId?: string
  logUID?: string
  updateLogData: (files: AudioRef[] | undefined) => void
  defaultValue: AudioRef[]
  files: FileItem[]
}) => {
  const { deleteAudio, loadingStorage } = useStorage()

  const handleDeletePersisted = async (audio: AudioRef) => {
    if (!userId || !logUID) return
    try {
      await deleteAudio(userId, logUID, audio.path ?? audio.url)
      const remaining = defaultValue.filter((item) => item.url !== audio.url)
      updateLogData(remaining.length > 0 ? remaining : undefined)
      toast.success('Archivo eliminado de la lista')
    } catch (err) {
      console.error('Error al eliminar archivo persistido:', err)
      toast.error('Error al eliminar archivo')
    }
  }

  const visibleAudios = useMemo(() => {
    if (files.length === 0) return defaultValue
    const pendingNames = new Set(
      files.map((item) => item.file.name.toLowerCase()),
    )
    const pendingUrls = new Set(
      files
        .map((item) => item.url?.toLowerCase())
        .filter((url): url is string => Boolean(url)),
    )
    return defaultValue.filter((audio) => {
      const matchesName = pendingNames.has(audio.title.toLowerCase())
      const matchesUrl =
        audio.url !== undefined && pendingUrls.has(audio.url.toLowerCase())
      return !matchesName && !matchesUrl
    })
  }, [defaultValue, files])

  return (
    <>
      {visibleAudios.map((file) => (
        <FilesList key={file.url}>
          <UploadedItems>
            <span>
              <PiFileAudio className="icon" />
              <a
                href={file.url}
                target="_blank"
                rel="noreferrer"
                aria-label={file.title}
              >
                {file.title.slice(0, file.title.lastIndexOf('.'))}
              </a>
            </span>
            <UploadedItemsBtn
              $action="delete"
              type="button"
              onClick={() => handleDeletePersisted(file)}
              disabled={loadingStorage}
            >
              <PiTrash className="icon" />
              {/* Eliminar */}
            </UploadedItemsBtn>
          </UploadedItems>
        </FilesList>
      ))}
    </>
  )
}

export default UploadedFilesList
